// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";

// const Register = () => {
//   const [user, setUser] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//     companyName: "",
//     gstNumber: "",
//   });
//   const navigate = useNavigate();

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // localStorage.setItem("user", JSON.stringify(user)); // Save user in localStorage (mock database)
//     alert("Registration successful! Now login.");
//     navigate("/login"); // Updated route to /login
//   };

//   return (
//     <div className="flex justify-center items-center min-h-screen  bg-gradient-to-b from-indigo-100 via-white to-purple-100 px-4">
//       <motion.form
//         className="relative bg-white p-5 sm:p-6 shadow-2xl rounded-2xl w-full max-w-sm sm:max-w-md lg:max-w-lg"
//         onSubmit={handleSubmit}
//         initial={{ opacity: 0, y: -30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6, ease: "easeOut" }}
//       >
//         <h2 className="text-xl sm:text-2xl font-extrabold mb-4 sm:mb-5 text-center text-gray-800 tracking-wider">
//           Get Started
//         </h2>

//         {/* First Name & Last Name - Same Row */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
//           <motion.input
//             type="text"
//             placeholder="First Name"
//             className="w-full p-2.5 sm:p-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out text-sm"
//             onChange={(e) => setUser({ ...user, firstName: e.target.value })}
//             required
//             whileFocus={{ scale: 1.01 }}
//           />
//           <motion.input
//             type="text"
//             placeholder="Last Name"
//             className="w-full p-2.5 sm:p-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out text-sm"
//             onChange={(e) => setUser({ ...user, lastName: e.target.value })}
//             required
//             whileFocus={{ scale: 1.01 }}
//           />
//         </div>

//         {/* Email */}
//         <motion.input
//           type="email"
//           placeholder="Email Address"
//           className="w-full mt-2 sm:mt-3 p-2.5 sm:p-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out text-sm"
//           onChange={(e) => setUser({ ...user, email: e.target.value })}
//           required
//           whileFocus={{ scale: 1.01 }}
//         />

//         {/* Phone */}
//         <motion.input
//           type="number"
//           placeholder="Phone Number"
//           className="w-full mt-2 sm:mt-3 p-2.5 sm:p-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out text-sm"
//           onChange={(e) => setUser({ ...user, phone: e.target.value })}
//           required
//           whileFocus={{ scale: 1.01 }}
//         />

//         {/* Password */}
//         <motion.input
//           type="password"
//           placeholder="Password"
//           className="w-full mt-2 sm:mt-3 p-2.5 sm:p-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out text-sm"
//           onChange={(e) => setUser({ ...user, password: e.target.value })}
//           required
//           whileFocus={{ scale: 1.01 }}
//         />

//         {/* Confirm Password */}
//         <motion.input
//           type="password"
//           placeholder="Confirm Password"
//           className="w-full mt-2 sm:mt-3 p-2.5 sm:p-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out text-sm"
//           onChange={(e) =>
//             setUser({ ...user, confirmPassword: e.target.value })
//           }
//           required
//           whileFocus={{ scale: 1.01 }}
//         />

//         {/* Company Name & GST - Same Row */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 mt-2 sm:mt-3">
//           <motion.input
//             type="text"
//             placeholder="Company Name (Optional)"
//             className="w-full p-2.5 sm:p-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out text-sm"
//             onChange={(e) => setUser({ ...user, companyName: e.target.value })}
//             whileFocus={{ scale: 1.01 }}
//           />
//           <motion.input
//             type="number"
//             placeholder="GST Number (Optional)"
//             className="w-full p-2.5 sm:p-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out text-sm"
//             onChange={(e) => setUser({ ...user, gstNumber: e.target.value })}
//             whileFocus={{ scale: 1.01 }}
//           />
//         </div>

//         {/* Register Button */}
//         <motion.button
//           className="w-full bg-[#673AB7] text-white p-2.5 sm:p-3 rounded-lg font-bold shadow-md hover:bg-purple-700 transition-colors duration-300 ease-in-out mt-4 sm:mt-5"
//           whileHover={{ scale: 1.02 }}
//           whileTap={{ scale: 0.98 }}
//         >
//           Register
//         </motion.button>

//         {/* Login Redirect */}
//         <p className="text-center text-gray-600 mt-3 sm:mt-4 text-sm">
//           Already have an account?{" "}
//           <span
//             className="text-[#673AB7] font-semibold cursor-pointer hover:underline"
//             onClick={() => navigate("/login")} // Updated route to /login
//           >
//             Login here
//           </span>
//         </p>
//       </motion.form>
//     </div>
//   );
// };

// export default Register;







import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";

import Image1 from "../../assets/login.webp";
import image2 from "../../assets/loginlogo.png";

const Register = () => {
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    companyName: "",
    gstNumber: "",
  });
  
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Registration successful! Now login.");
    navigate("/login");
  };

  return (
    <div className="flex h-screen w-full bg-white overflow-hidden">
      
      {/* LEFT SECTION - IMAGE */}
      <div className="hidden lg:flex lg:w-1/2 relative bg-gray-100 items-center justify-center h-full">
        <img
          src={Image1}
          alt="Register Banner"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/40 to-purple-900/40 mix-blend-multiply" />
      </div>

      {/* RIGHT SECTION - REGISTER FORM */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center items-center relative bg-white p-4 sm:p-8 lg:px-16 h-full overflow-y-auto">
        
        {/* Logo - EXACTLY MATCHING LOGIN PAGE SIZING */}
        <div className="absolute top-6 left-6 sm:top-8 sm:left-12 lg:left-8 xl:left-12 z-20">
          <img 
            src={image2}
            alt="Logo Placeholder" 
            className="h-10 sm:h-12 lg:h-14 w-auto" 
          />
        </div>

        <motion.div
          className="w-full max-w-md z-10 mt-28 sm:mt-32 lg:mt-24 py-2"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <form className="w-full" onSubmit={handleSubmit}>
            
            {/* Header */}
            <div className="mb-4 text-center sm:text-left">
              <h2 className="text-2xl font-bold text-gray-900 mb-1">
                Get Started
              </h2>
              <p className="text-gray-500 text-sm">
                Create a new account to continue.
              </p>
            </div>

            {/* First Name & Last Name - Same Row */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-1">First Name</label>
                <input
                  type="text"
                  placeholder="First Name"
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all text-sm"
                  onChange={(e) => setUser({ ...user, firstName: e.target.value })}
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-1">Last Name</label>
                <input
                  type="text"
                  placeholder="Last Name"
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all text-sm"
                  onChange={(e) => setUser({ ...user, lastName: e.target.value })}
                  required
                />
              </div>
            </div>

            {/* Email Address */}
            <div className="mb-3">
              <label className="block text-gray-700 text-sm font-medium mb-1">Email Address</label>
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all text-sm"
                onChange={(e) => setUser({ ...user, email: e.target.value })}
                required
              />
            </div>

            {/* Phone Number */}
            <div className="mb-3">
              <label className="block text-gray-700 text-sm font-medium mb-1">Phone Number</label>
              <input
                type="number"
                placeholder="Enter your phone number"
                className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all text-sm"
                onChange={(e) => setUser({ ...user, phone: e.target.value })}
                required
              />
            </div>

            {/* Password & Confirm Password */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-1">Password</label>
                <input
                  type="password"
                  placeholder="Password"
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all text-sm"
                  onChange={(e) => setUser({ ...user, password: e.target.value })}
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-1">Confirm Password</label>
                <input
                  type="password"
                  placeholder="Confirm Password"
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all text-sm"
                  onChange={(e) => setUser({ ...user, confirmPassword: e.target.value })}
                  required
                />
              </div>
            </div>

            {/* Company Name & GST */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5">
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-1">Company Name <span className="text-xs text-gray-400">(Optional)</span></label>
                <input
                  type="text"
                  placeholder="Company Name"
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all text-sm"
                  onChange={(e) => setUser({ ...user, companyName: e.target.value })}
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-1">GST Number <span className="text-xs text-gray-400">(Optional)</span></label>
                <input
                  type="text"
                  placeholder="GST Number"
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all text-sm"
                  onChange={(e) => setUser({ ...user, gstNumber: e.target.value })}
                />
              </div>
            </div>

            {/* Register Button */}
            <button
              type="submit"
              className="w-full py-2.5 bg-[#673AB7] text-white font-semibold rounded-lg hover:bg-[#512DA8] transition-colors duration-300 shadow-sm"
            >
              Create Account
            </button>

            {/* Login Link & Back to Website */}
            <div className="mt-4 text-center space-y-1.5">
              <p className="text-sm text-gray-600">
                Already have an account?{" "}
                <Link
                  to="/login"
                  className="text-[#673AB7] hover:text-[#512DA8] font-bold transition-colors underline"
                >
                  Sign in here
                </Link>
              </p>
              
              <div className="text-sm text-gray-600 flex items-center justify-center gap-1">
                Go back to{" "}
                <Link
                  to="/"
                  className="font-bold text-[#00AD8C] hover:text-[#008c73] transition-colors flex items-center gap-1"
                >
                  Website <FaArrowRight size={10} />
                </Link>
              </div>
            </div>

          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Register;